import { render, staticRenderFns } from "./SessionInfoCard.vue?vue&type=template&id=270049f4&scoped=true"
import script from "./SessionInfoCard.vue?vue&type=script&lang=ts"
export * from "./SessionInfoCard.vue?vue&type=script&lang=ts"
import style0 from "./SessionInfoCard.vue?vue&type=style&index=0&id=270049f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270049f4",
  null
  
)

export default component.exports